// footer menu dropdown

$(document).ready(function () {
  $(".explore-title").click(function () {
    if ($(this).hasClass("close")) {
      $(this).removeClass("close").addClass("open");
    } else if ($(this).hasClass("open")) {
      $(this).removeClass("open").addClass("close");
    }

     $(".footer-menu-blocks").stop(true, true).slideToggle(500);
  });

  $(document).on("click", ".close-menu", function () {
    const parent_menu = $(this).parents(".mega-menu");

    if (parent_menu.attr("open")) {
      parent_menu.removeAttr("open");
    }
  });
});


// mega menu hover



document.addEventListener("DOMContentLoaded", function () {
    let items = document.querySelectorAll(".header__inline-menu details");

    items.forEach((item) => {
        item.addEventListener("mouseenter", () => {
            // Close all other open menus before opening a new one
            items.forEach((otherItem) => {
                if (otherItem !== item) {
                    otherItem.removeAttribute("open");
                    otherItem.querySelector("summary").setAttribute("aria-expanded", "false");
                    fadeOut(otherItem.querySelector(".mega-menu"));
                }
            });

            // Open the hovered menu
            item.setAttribute("open", "true");
            item.querySelector("summary").setAttribute("aria-expanded", "true");
            fadeIn(item.querySelector(".mega-menu"));
        });

        item.addEventListener("mouseleave", () => {
            setTimeout(() => {
                if (!item.matches(":hover") && !item.querySelector(".mega-menu:hover")) {
                    item.removeAttribute("open");
                    item.querySelector("summary").setAttribute("aria-expanded", "false");
                    fadeOut(item.querySelector(".mega-menu"));
                }
            }, 200); // Adding a small delay to prevent flickering
        });
    });

    // Click outside to close all menus
    document.addEventListener("click", function (event) {
        if (!event.target.closest(".header__inline-menu details, .mega-menu")) {
            items.forEach((item) => {
                item.removeAttribute("open");
                item.querySelector("summary").setAttribute("aria-expanded", "false");
                fadeOut(item.querySelector(".mega-menu"));
            });
        }
    });

    // Press Escape key to close all menus
    document.addEventListener("keyup", function (event) {
        if (event.key === "Escape") {
            items.forEach((item) => {
                item.removeAttribute("open");
                item.querySelector("summary").setAttribute("aria-expanded", "false");
                fadeOut(item.querySelector(".mega-menu"));
            });
        }
    });

    // Fade In Effect
    function fadeIn(element) {
        if (!element) return;
        element.style.opacity = 0;
        element.style.display = "block";
        let opacity = 0;
        let interval = setInterval(() => {
            opacity += 0.1;
            element.style.opacity = opacity;
            if (opacity >= 1) clearInterval(interval);
        }, 20);
    }

    // Fade Out Effect
    function fadeOut(element) {
        if (!element) return;
        let opacity = 1;
        let interval = setInterval(() => {
            opacity -= 0.1;
            element.style.opacity = opacity;
            if (opacity <= 0) {
                clearInterval(interval);
                element.style.display = "none";
            }
        }, 20);
    }
});

